<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit1"><a id="page_ii"></a><a id="page_iii"></a><span class="bold">Hotspur</span></h1>
<p class="stit1"><span class="bold">Sir Henry Percy and the</span></p>
<p class="stit2"><span class="bold">Myth of Chivalry</span></p>
<p class="stit3"><em class="italic">L’audace, l’audace, toujors l’audace</em> (Danton)</p>
<p class="author1"><span class="bold">John Sadler</span></p>
<p class="author2"><span class="bold"><em class="italic">Foreword by Ralph Percy,</em></span></p>
<p class="author3"><span class="bold"><em class="italic">12th Duke of Northumberland</em></span></p>
<div class="img_container">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?0762f234